<template>
	<div>
		<slot name="navbar">
			<navbar></navbar>
		</slot>
		<slot></slot>
	</div>
</template>
<script>
	import Navbar from '@/components/Navbar.vue'
	export default {
		components: {
			Navbar
		}		
	}
</script>